export class KieneConstants {
    static STATUS = class {
        static UNTERSUCHUNGSAUFTRAG = class {
            static ERSTELLT = 91;
            static ABGESCHLOSSEN = 92;
        };
    };
}
